<template>
  <div class="cont">
        <div class="echarts-title" style="display: flex" v-if="Object.keys(tableObj).length">
            <div class="item-wrap">
                <div>All Money: <span>￥{{tableObj.total_money}}</span></div>
                <div>Wait Money: <span>￥{{tableObj.total_wait_money}}</span></div>
                <div>Settled Money: <span>￥{{tableObj.total_yes_money}}</span></div>
            </div>
            <div class="item-wrap">
                <div>All Quantity: <span>￥{{tableObj.total_num}}</span></div>
                <div>Wait Quantity: <span>￥{{tableObj.total_wait_num}}</span></div>
                <div>Settled Money: <span>￥{{tableObj.total_yes_num}}</span></div>
            </div>
        </div>

        <div class="Echarts" style="display: flex" v-if="Object.keys(tableObj).length">
            <div id="myChart1" :style="{flex: 1, height: '300px'}"></div>
            <div id="myChart2" :style="{flex: 1, height: '300px'}"></div>
        </div>


      <div class="form-wrap">
        <el-input class="input mgr10" v-model="keyword" :placeholder="$t('plaseEnter', {text: ''})" clearable></el-input>
        <el-select class="select mgr10" v-model="type" :placeholder="$t('pleaseSelectTheProduct')">
            <el-option v-for="(item, idx) in items" 
            :key="idx" :label="item.label" :value="item.val"></el-option>
        </el-select>

        <el-date-picker
            class="picker mgr10"
            v-model="value1"
            type="daterange"
            :clearable="true"
            value-format="yyyy-MM-dd"
            range-separator="-"
            start-placeholder="Start date "
            end-placeholder="Ending date ">
        </el-date-picker>

        <el-button type="danger" @click="init">{{$t('search')}}</el-button>
      </div>

      <div>
        <el-table
        v-loading = "pictLoading"
        :empty-text="$t('noData')"
        :data="tableData"
        style="width: 100%">
            <el-table-column
                label=""
                width="100">
                <template slot-scope="scope">
                    <div class="icons">
                        <img class="table-icon" v-if="scope.row.type == 2" src="@/assets/images/channel/settled.png" alt="">
                        <img class="table-icon" v-else src="@/assets/images/channel/unsettled.png" alt="">
                    </div>
                </template>
            </el-table-column>
            <el-table-column  width="180" prop="money" label="Money"  > </el-table-column>
            <el-table-column prop="nickname" label="User" ></el-table-column>
            <el-table-column  prop="ctime" label="Date" > </el-table-column>
            <el-table-column  prop="type_name"  label="State" > </el-table-column>
            <el-table-column
                label="Auction"
                width="100">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" v-if="scope.row.type !='2'" type="text" size="small">Closing</el-button>
                </template>
            </el-table-column>
        </el-table>
      </div>

      <Pagination
        :totalPage="totalPage"
        :limit="10"
        @changePage="handleCurrentChange"
      ></Pagination>

        <el-dialog
            title="Tips"
            :visible.sync="dialogVisible"
            width="30%">
            <div class="title"> {{currentUser.nickname}} Commission：{{currentUser.money}}</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">Cancel</el-button>
                <el-button type="primary" @click="agree">Agree</el-button>
            </span>
        </el-dialog>

  </div>
</template>

<script>
import Pagination from "@/components/common/Pagination.vue";
export default {
    components: {
        Pagination
    },
    data() {
        return {
            items: [
                {label: "All",     val: ''},
                {label: "Unsettled",   val:'1'}, // 未结算
                {label: "Settled",   val:'2'} // 已结算
            ],
            pictLoading: true,
            tableData: [],
            totalPage: 1,
            form: {
                limit: 10,
                page: 1
            },
            value1: '',
            type: '',
            keyword: '',
            dialogVisible: false,
            currentUser: {},
            tableObj: {}
        }
    },
    mounted() {
        this.init()
    },
     watch: {
        type() {
            this.form.page = 1
        }
    },
    methods: {
        
        agree() {
            const _this = this
            this.$api.examine({type: 2, id: this.currentUser.id}).then( res => {
                this.$message({
                    message:  res.status ? (res.msg || '成功') : '失败',
                    type: res.status ? 'success' : 'error'
                })
                if(res.status) {
                    _this.dialogVisible = false
                    _this.init()
                }
            })
        },
        handleClick(v) {
            this.dialogVisible = true
            this.currentUser = v
        },
        handleCurrentChange(v) {
            this.form.page = v
            this.init()
        },
        init() {
            this.pictLoading = true
            let form = {...this.form}
            this.keyword && (form.keyword   = this.keyword)
            this.type    && (form.type      = this.type)
            if(this.value1) {
                form.start_date      = this.value1[0]
                form.end_date        = this.value1[1]
            }
            this.$api.bussinesswithdrawallist(form).then(res =>{
                this.pictLoading = false
                if(res.status) {
                    if(Array.isArray(res.data) && res.data.length == 0) {
                        return
                    }
                    this.tableData = res.data
                    this.tableObj = res
                    this.totalPage = res.total
                    let column_money = res.column_money
                    for(let i of column_money.series) {
                        i['type'] = 'bar'
                        i.itemStyle = {
                            normal: {
                                label: {
                                    show: true,		//开启显示
                                    position: 'top',	//在上方显示
                                    textStyle: {	    //数值样式
                                        color: 'black',
                                        fontSize: 16
                                    }
                                }
                            }
                        }
                    }

                    let column_num = res.column_num
                    for(let i of column_num.series) {
                        i['type'] = 'bar'
                        i.itemStyle = {
                            normal: {
                                label: {
                                    show: true,		//开启显示
                                    position: 'top',	//在上方显示
                                    textStyle: {	    //数值样式
                                        color: 'black',
                                        fontSize: 16
                                    }
                                }
                            }
                        }
                    }

                    this.$nextTick(() =>{
                        this.myEcharts('myChart1', column_money, {text: 'Money', legendData: {
                            data: ['Wait', 'Settled']
                        }})

                        this.myEcharts('myChart2', column_num, {text: 'Number', legendData: {
                            data: ['Wait', 'Settled']
                        }})
                    })
                    
                    
                }
            })
        },
        myEcharts(id, val, obj){
		  // 基于准备好的dom，初始化echarts实例
		  var myChart = this.$echarts.init(document.getElementById(id));

          console.log('val', val.series)
		  // 指定图表的配置项和数据
		  var option = {
                title: { text: obj.text || ""  },
                tooltip: {},
                legend: obj.legendData,
                xAxis: {
                    data: val.categories,
                    axisLabel:{  
                        interval: 0
                    }
                },
                yAxis: {},
                series: val.series
		  };

		  // 使用刚指定的配置项和数据显示图表。
		  myChart.setOption(option);
        },
    }
}
</script>

<style lang="scss" scoped>
.mgr10 {
    margin-right: 10px;
}
.table-icon {
    width: 30px;
    height: 30px;
}
.title {
    text-align: center;
    margin-top: 40px;
    margin-bottom: 20px;
}
.icons {
    display: flex;
    align-items: center;
}
.cont {
    // width: 700px;
}
.form-wrap{
    display: flex;
    align-items: center;
    .input {
        width: 300px;
    }
}

.echarts-title {
    .item-wrap {
        flex: 1;
        div {
            font-weight: bold;
            font-size: 20px;
            margin-bottom: 14px;
            text-align: center;
            span {
                color: #ff4444;
            }
        }
    }
}
</style>